import { yupToFormErrors } from 'formik';
import * as Yup from 'yup';

const AliasSchema = Yup.object().shape({
  alias: Yup.string().required('Acest camp este obligatoriu.'),
});

export default AliasSchema;
